import {
  FAQS,
  SWAF_INFO_TEXT,
  REGISTRATION_CARDS,
  TERMS_AND_CONDITION,
  ADD_ON_PURCHASE_SUCCESS_MESSAGE,
} from "./helper";
import { routes } from "src/shared/routes";
import { constants } from "src/shared/constants";

import type { TTeamConfig } from "src/shared/types/teamConfig.types";

const LOGO_URL = "https://ss-leagues.s3.amazonaws.com/NCAA/I-State_3Color.png";
const ORDER_SUMMERY_BACKGROUND_URL =
  "https://ss-leagues.s3.amazonaws.com/NCAA/Iowa%20State/Student%20Athlete%20Sign-Up%281920x450px%29.jpg";
const MOBILE_LANDING_PAGE_STATIC_BANNER_URL =
  "https://ss-leagues.s3.amazonaws.com/NCAA/Iowa%20State/Student%20Athlete%20Sign-Up%28375x550px%29.jpg";
const LANDING_PAGE_STATIC_BANNER_URL =
  "https://ss-leagues.s3.amazonaws.com/NCAA/Iowa%20State/Student%20Athlete%20Sign-Up%281920x450px%29.jpg";
const GROUP_INVITE_PAGE_STATIC_BANNER_URL =
  "https://ss-leagues.s3.amazonaws.com/NCAA/Iowa%20State/Student%20Athlete%20Sign-Up%281920x450px%29.jpg";

export const iowastate_studentathletes: TTeamConfig = {
  TEAM_SCHEMA: "iowastate_studentathletes",
  BROWSER_TITLE: "ISU Student Athlete Tickets",
  TEAM_FULL_NAME: "ISU Student Athlete Tickets",
  VENDOR: constants.vendorUUIDs.ticketmaster,
  CLIENT_ID: "19a40b80a8b7.seasonshare.isu-isu.us",

  TEAM_GLOBAL_SETTINGS: {
    COLORS_PRIMARY: "#C8102E",
    COLORS_SECONDARY: "#CAC7A7",
    LOGOUT_ON_INVALID_SESSION: false,
    DEFAULT_APP_ROUTE: routes.landing,
    DISABLE_PASS_ON_ACCOUNT_RESTRICTION: true,

    NAV_MENU: {
      HIDE_EARN_REWARDS: true,
      HIDE_PURCHASE_HISTORY: true,
      HIDE_MANAGE_SUBSCRIPTION: true,
    },

    IS_INTERCOM_ENABLED: true,
  },

  LANDING_PAGE_SETTINGS: {
    HIDE_PASSES: true,
    HIDE_UPCOMING_EVENTS: true,

    PASS_BANNER: {
      PASS_DISPLAY_MODE: "separate",
      IS_FLUID_BACKGROUND_IMAGE_SIZE: true,
      DISABLE_BACKGROUND_IMAGE_FILTER: true,
    },

    REGISTRATION_CARD_SETTINGS: {
      REGISTRATION_CARDS,
      HIDE_SECTION_TITLE: true,
    },

    PASS: {
      HIDE_DECIMAL_POINTS_AFTER_PRICE: true,
      SUBSCRIBE_BUTTON_TEXT: "Purchase Now",
    },

    STATIC_BANNER: {
      IS_ENABLED: true,
      IS_FLUID_BACKGROUND_IMAGE_SIZE: true,
    },

    SHOW_ALL_EVENTS_UNDER_PASS: true,
  },

  HOME_PAGE_SETTINGS: {
    EVENT_CARD: {
      SHOW_SINGLE_GAMES_IN_COLLAPSE: false,
    },

    ADD_ON: {
      ADD_ON_PURCHASE_SUCCESS_MESSAGE,
    },
  },

  MY_GROUP_PAGE_SETTINGS: {
    PAGE_INFO_TEXT: <SWAF_INFO_TEXT />,
  },

  GROUP_INVITE_PAGE_SETTINGS: {
    PASS_BANNER: {
      DISABLE_BACKGROUND_IMAGE_FILTER: true,
      PASS_DISPLAY_MODE: "separate",
    },
  },

  CHECKOUT_PAGE_SETTINGS: {
    CHECKOUT_FORM: {
      SAVE_CARD_SWITCH_ENABLED: true,
    },

    ADD_ONS_LABEL: "Tickets",
  },

  IMAGES: {
    LOGO_URL,
    ORDER_SUMMERY_BACKGROUND_URL,
    LANDING_PAGE_STATIC_BANNER_URL,
    GROUP_INVITE_PAGE_STATIC_BANNER_URL,
    MOBILE_LANDING_PAGE_STATIC_BANNER_URL,
  },

  LANGUAGES: {
    FAQS,
    TERMS_AND_CONDITION,
  },
};
